import { useMountEffect } from 'hooks'
import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay/hooks'
import { usePage, useAuth } from 'hooks'
import Integrations from './Integrations'

export default function IntegrationsContainer() {
  const { setHeader } = usePage()
  const { currentCompany } = useAuth()

  useMountEffect(() => {
    setHeader({ crumbs: [{ label: 'Integrations', value: 'integrations' }] })
  })

  const data = useLazyLoadQuery(
    graphql`
      query IntegrationsContainerQuery($companyId: ID!) {
        companyById(id: $companyId) {
          ...Integrations_company
        }
      }
    `,
    { companyId: currentCompany.id },
  )

  return <Integrations company={data.companyById} />
}
